"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableCorrelationTable = void 0;
var d3 = require("d3");
var React = require("react");
var react_1 = require("react");
var Localize_1 = require("../../gen-src/Localize");
var styles = require("../styles/PredictionModelResultsViz");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
var utils_1 = require("../util/utils");
var VariableCorrelationTable = function (props) {
    var data = props.data, showChart = props.showChart, title = props.title, description = props.description, hideBorder = props.hideBorder;
    var chartRef = react_1.useRef(null);
    var sortedData = data.sort(function (item1, item2) {
        return d3.descending(item1.correlation, item2.correlation);
    });
    // TODO: Figure out math to align horizontal bar chart with table
    var marginBottom = 30;
    var cellHeight = sizes.varCorrelationTableCellHeight;
    var chartHeight = cellHeight * data.length + 4;
    var height = chartHeight + marginBottom;
    var chartWidth = sizes.widthNarrow;
    var xScale = d3.scaleLinear().range([0, chartWidth]).domain([0, 1]);
    var yScale = d3
        .scaleBand()
        .rangeRound([0, chartHeight])
        .paddingInner(0.1)
        .paddingOuter(0.1)
        .domain(sortedData.map(function (d) {
        return d.name;
    }));
    var drawAxes = react_1.useCallback(function () {
        var svg = d3.select(chartRef.current);
        // draw xAxis
        var xAxis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(xAxis, sizes.defaultNumTicks, sizes.defaultTickSize, sizes.defaultTickPadding, utils_1.TickFormat.hideEnds);
        utils_1.drawAxis(svg, xAxis, 0, chartHeight);
        // draw background lines
        var backgroundAxis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(backgroundAxis, sizes.defaultNumTicks, -chartWidth, sizes.defaultTickPadding, utils_1.TickFormat.hideNumbers);
        utils_1.drawAxisGridLines(svg, backgroundAxis, 0, chartHeight);
    }, [chartHeight, chartWidth, xScale]);
    var drawBars = react_1.useCallback(function () {
        var bars = d3.select(chartRef.current).selectAll('.bar').data(data).enter().append('g');
        bars
            .append('rect')
            .attr('class', 'bar')
            .attr('y', function (d) {
            return yScale(d.name) || 0;
        })
            .attr('fill', colors.defaultBlue)
            .attr('height', sizes.varCorrelationTableCellHeight - 5) // acount for padding
            .attr('x', 0)
            .attr('width', function (d) {
            return xScale(d.correlation) || 0;
        });
    }, [data, xScale, yScale]);
    react_1.useEffect(function () {
        d3.select(chartRef.current).selectAll('*').remove(); // To avoid stacking svg every re-render
        var svg = d3.select(chartRef.current).attr('width', chartWidth).attr('height', height);
        drawAxes();
        utils_1.drawAxisLabel(svg, Localize_1.Messages.Correlation(), chartWidth / 2, chartHeight + marginBottom);
        drawBars();
    }, [chartHeight, chartWidth, data, drawAxes, drawBars, height]);
    var getRows = function () {
        return sortedData.map(function (_a) {
            var name = _a.name, correlation = _a.correlation;
            return (React.createElement("tr", { key: name, className: styles.VarCorrelationTableRow },
                React.createElement("td", { className: styles.VarCorrelationTableCell }, name),
                React.createElement("td", { className: styles.VarCorrelationTableCell }, correlation)));
        });
    };
    var renderChart = function () {
        return (React.createElement("div", { className: styles.VarCorrelationTableChart },
            React.createElement("svg", { ref: chartRef })));
    };
    var getCardSizeClass = function () {
        // TODO: Move this somewhere else?
        var cardClass = '';
        if (showChart) {
            cardClass = cardClass + ' ' + styles.cardContainerWide;
        }
        else {
            cardClass = cardClass + ' ' + styles.cardContainer;
        }
        return cardClass;
    };
    return (React.createElement("div", { className: hideBorder ? getCardSizeClass() : getCardSizeClass() + ' ' + styles.cardBorderShadow },
        React.createElement("div", { className: hideBorder ? styles.card : styles.cardBorder + ' ' + styles.card },
            title && React.createElement("label", { className: styles.cardTitle }, title),
            description && React.createElement("label", { className: styles.cardDescription }, description),
            React.createElement("div", { className: styles.VarCorrelationTableContainer },
                React.createElement("table", { className: showChart ? styles.VarCorrelationTableWithChart : styles.VarCorrelationTable },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { className: styles.VarCorrelationTableHeader }, Localize_1.Messages.Variable()),
                            React.createElement("th", { className: styles.VarCorrelationTableHeader }, showChart ? Localize_1.Messages.Correlation() : Localize_1.Messages.CorrelationWithOutcome()))),
                    React.createElement("tbody", null, getRows())),
                showChart && renderChart()))));
};
exports.VariableCorrelationTable = VariableCorrelationTable;
//# sourceMappingURL=VariableCorrelationTable.js.map